import { HeartHandshake } from 'lucide-react';
import { BRAND_PHOTOS } from '../../lib/brand';
import { CAUSES } from './landingData';

export const CommunitySection = () => (
  <section id="community" className="relative py-20 sm:py-28 px-6 sm:px-10 overflow-hidden" data-testid="community-section">
    <img src={BRAND_PHOTOS.dining} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-[#3E2418]/92 backdrop-blur-[2px]" />
    <div className="relative max-w-7xl mx-auto text-white">
      <div className="max-w-2xl">
        <p className="text-[11px] uppercase tracking-[0.3em] text-orange-300 font-semibold mb-4 flex items-center gap-2"><HeartHandshake className="w-4 h-4" /> Community &amp; charity</p>
        <h2 className="text-3xl sm:text-4xl font-black tracking-tight leading-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Good neighbours in every town we serve.
        </h2>
        <p className="text-white/75 mt-5 leading-relaxed text-base">
          Our restaurants are run by local people, for local people. Giving back is part of how we operate — nationally with A&amp;W Canada and locally in each community.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-5 mt-12 stagger" data-testid="community-causes">
        {CAUSES.map((c) => (
          <article key={c.title} className="glass-dark rounded-2xl p-6 flex flex-col hover:bg-white/10 transition-colors">
            <span className="self-start text-[10px] uppercase tracking-wider font-bold text-amber-300 bg-amber-400/15 rounded-full px-2.5 py-1">{c.tag}</span>
            <h3 className="text-xl font-black mt-4" style={{ fontFamily: 'Chivo, sans-serif' }}>{c.title}</h3>
            <p className="text-xs text-orange-200/80 mt-1">{c.org}</p>
            <p className="text-sm text-white/75 mt-3 leading-relaxed">{c.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
